import { getParam } from "api/search/filterUrlMaker";
import React, { useState } from "react";
import { AutoSuggestions } from "../../viewLayout/searchBox/AutoSuggestions";
import { SearchBox } from "../../viewLayout/searchBox/SearchBox";

export const MobileSearchBox = () => {
  const defaultKeyword = getParam("") || getParam("title") || "";
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [isAcVisible, setAcVisible] = useState(false);
  const [isSearching, setIsSearching] = useState();

  return (
    <section className="px-2">
      <SearchBox
        keyword={keyword}
        setKeyword={setKeyword}
        setAcVisible={setAcVisible}
        setIsSearching={setIsSearching}
        isSearching={isSearching}
        className="rounded-xl-left"
        size="sm"
        isDropdownVisible={false}
        autoFocus
      />
      {isAcVisible && <AutoSuggestions keyword={keyword} setKeyword={setKeyword} />}
    </section>
  );
};
